import React, { useCallback, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import DeleteTemplateElementDialog from "./DeleteTemplateElementDialog";
import { TemplateElementOptions } from "./Tasks/TemplateElementOptions";

export const ProjectTemplateElementsOptionsContainer = ({ elementId, elementType, templateId }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const [id, setId] = useState(null);

  const handleEdit = useCallback(() => {
    navigate(location.pathname + location.search, {
      replace: true,
      state: { edit: true },
    });
  }, [navigate, location.pathname, location.search]);

  return (
    <>
      <TemplateElementOptions
        onDelete={() => setId(elementId)}
        onEdit={handleEdit}
      />
      {id ? (
        <DeleteTemplateElementDialog
          type={elementType}
          deleteElementId={elementId}
          setDeleteElementId={setId}
          templateId={+templateId}
        />
      ) : null}
    </>
  );
};

ProjectTemplateElementsOptionsContainer.propTypes = {
  elementId: PropTypes.number.isRequired,
  elementType: PropTypes.string.isRequired,
  templateId: PropTypes.number.isRequired,
};
